<template>
  <b-card
    no-body
    class="mb-5"
  >
    <b-row
      no-gutters
      align-v="stretch"
    >
      <!-- Image column -->
      <b-col
        class="d-none d-md-block"
        cols="12"
        lg="5"
        xxl="5"
        style="background-color: #FAFAFA; max-height: 450px"
      >
        <img
          :src="imageSrc"
          style="width: 100%; height: 100%; min-height: 400px; object-fit: cover"
          alt=""
        >
      </b-col>
      <b-col
        cols="12"
        lg="7"
        xxl="7"
        class="p-4 default-bg"
        align-self="stretch"
      >
        <b-row
          align-v="stretch"
          style="min-height: 100%"
        >
          <b-col cols="12">
            <h2
              class="mb-0 text-default med-font"
              style="font-size: 22px; line-height: 32px"
            >
              {{ item.medicinename }}
            </h2>
            <p class="mb-0">
              {{ displayDosage }} | {{ item.unit }} | {{ duration }}
            </p>
          </b-col>
          <b-col cols="12">
            <div class="d-block d-md-none pt-6"></div>

            <b-col cols="12">
              <div class="d-block d-md-none pt-6"></div>
              <b-row
                v-if="item.goodfor"
                class="mt-2 mb-2"
              >
                <b-col cols="12">
                  <b-list-group flush>
                    <b-list-group-item
                      class="d-flex text-default justify-content-between align-items-center"
                      style="cursor: pointer"
                      @click="
                        $emit(
                          'show-modal',
                          'What is this good for?',
                          item.goodfor.html
                        )
                      "
                    >
                      What this is good for <span class="next-arrow-cyan"></span>
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
              </b-row> 
              
              <b-row
                v-if="item.howtouse"
                class="mt-2 mb-2"
              >
                <b-col cols="12">
                  <b-list-group flush>
                    <b-list-group-item
                      class="d-flex text-default justify-content-between align-items-center"
                      style="cursor: pointer"
                      @click="
                        $emit(
                          'show-modal',
                          'How to Use',
                          item.howtouse.html
                        )
                      "
                    >
                      How to Use <span class="next-arrow-cyan"></span>
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
              </b-row> 

              <b-row
                v-if="item.whattoexpect.text"
                class="mt-2 mb-2"
              >
                <b-col cols="12">
                  <b-list-group flush>
                    <b-list-group-item
                      class="d-flex text-default justify-content-between align-items-center"
                      style="cursor: pointer"
                      @click="
                        $emit(
                          'show-modal',
                          'What to expect',
                          item.whattoexpect.html
                        )
                      "
                    >
                      What to expect <span class="next-arrow-cyan"></span>
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
              </b-row> 
              <b-row
                v-if="item.sideeffects.text"
                class="mt-2 mb-2"
              >
                <b-col cols="12">
                  <b-list-group flush>
                    <b-list-group-item
                      class="d-flex text-default justify-content-between align-items-center"
                      style="cursor: pointer"
                      @click="
                        $emit(
                          'show-modal',
                          'What are the side effects',
                          item.sideeffects.html
                        )
                      "
                    >
                      What are the side effects
                      <span class="next-arrow-cyan"></span>
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
              </b-row>
              <div class="d-none d-md-block text-right mt-4">
                <!-- Button to show description -->
                <b-button
                  pill
                  size="lg"
                  variant="info"
                  style="min-width: 220px"
                  :to="'/subscription/' + item.id"
                >
                  View subscription
                </b-button>
              </div>
              <div class="d-block d-md-none text-right mt-4">
                <!-- Button to show description -->
                <b-button
                  block
                  pill
                  variant="info"
                  :to="'/subscription/' + item.id"
                >
                  View subscription
                </b-button>
              </div>
              <div class="d-block d-md-none pb-3"></div>
            </b-col>
          </b-col>
        </b-row>
      </b-col>
      <b-col
        class="d-block d-md-none"
        cols="12"
        lg="5"
        xxl="5"
        style="background-color: #FAFAFA; max-height: 450px"
      >
        <img
          :src="imageSrc"
          style="width: 100%; height: 400px; object-fit: cover"
          alt=""
        >
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { getDisplayDosage } from '@/utils/prescription';

export default {
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      duration: ''
    }
  },
  computed: {
    imageSrc() {
      return this.item.image !== null
        ? this.item.image
        : require('@/assets/images/dashboard/articlebg.png');
    },
    displayDosage() {
      return getDisplayDosage(this.item.medicinename, this.item.dosage);
    },
  },
  async mounted() {
    switch (this.item.subscriptiontype) {
      case 'Monthly': 
        this.duration = 'Monthly Supply'
        break;
      case 'Quarterly':  
        this.duration = '3 Months Supply'
        break;
    }
  },
  methods: {
    formatGoodFor(content) {
      const result = content.map(item => {
        return item.name;
      });
      return result.join(', ');
    },
  },
};
</script>

<style lang="scss" scoped>
.list-group-item {
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-color: $primary;
  text-transform: uppercase;
  border-bottom-color: #b0baab;
  padding-bottom: 0.5rem;
  padding-top: 1.2rem;
}
</style>
